// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"31dfb7c7","610":"3bc83063"}[chunkId] + ".chunk.js";
};